import React from 'react';
const hlxLogoAlt = require('./assets/hlx-logo-alt.jpg');
const sklsiLogo = require('./assets/sklsi-logo.png');
const eisaiLogo = require('./assets/eisai-logo.png');
const burnHeaderImg = require('./assets/burn/burn_header.png');
const burnHeaderMobileImg = require('./assets/burn/burn_header_mobile.png');
const maciHeaderImg = require('./assets/maci/maci_header.png');
const maciHeaderMobileImg = require('./assets/maci/maci_header_mobile.png');
const burnFavicon = require('./assets/burn/burn_favicon.png');
const maciFavicon = require('./assets/maci/maci_favicon.png');

export default {
  sobix: {
    clientName: 'HELIX',
    customHeaderLogo: hlxLogoAlt
  },
  sklsi: {
    headerTitle: 'Educational Peer Event Registration',
    customHeaderLogo: sklsiLogo
  },
  axsomeprograms: {
    clientName: 'HELIX',
    landingInputLabel: 'Invitation Code',
    additionalInviteCodeFormat: '^(\\d+):(\\d+)$'
  },
  vericelburncare: {
    clientName: 'BURN',
    headerBanner: burnHeaderImg,
    headerBannerMobile: burnHeaderMobileImg,
    headerBannerAlt: 'Burn',
    pageTitle: 'Burn Event Registration',
    favicon: burnFavicon,
    footerLines: [
      [
        { text: 'Vericel® and the Vericel logo are registered', block: true },
        { text: ' trademarks of Vericel Corporation.' }
      ],
      [
        { text: '©2026 Vericel Corporation. All rights', block: true },
        { text: ' reserved. PP.US.VBC.0012' }
      ]
    ]
  },
  vericelmaci: {
    clientName: 'MACI',
    headerBanner: maciHeaderImg,
    headerBannerMobile: maciHeaderMobileImg,
    headerBannerAlt: 'MACI',
    pageTitle: 'MACI Event Registration',
    favicon: maciFavicon,
    hasIsi: true,
    footerLines: [
      [
        { text: 'MACI®, MACI Arthro®, Vericel®, and the', block: true },
        { text: ' ' },
        { text: 'Vericel logo are registered trademarks', block: true },
        { text: ' of Vericel Corporation.' }
      ],
      [
        { text: '©2026 Vericel Corporation. All rights', block: true },
        { text: ' reserved. PP.US.MAC.3041' }
      ]
    ]
  },
  esi: {
    clientName: 'EISAI',
    topHeaderElems: (
      <>
        <a
          href="https://us.eisai.com/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'white', marginRight: 10, fontWeight: 'bold' }}
        >
          Privacy Policy
        </a>
        <a
          href="https://us.eisai.com/legal-notices"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'white', fontWeight: 'bold' }}
        >
          Legal Notices
        </a>
      </>
    ),
    customHeaderLogo: eisaiLogo,
    customHeaderLogoStyle: { height: 150 },
    bottomPageText: `
      <h3>Speaker Program Information:</h3>
      <p class="bold">A meal may be offered. Alcohol will not be provided.</p>
      <p>
        Eisai complies with all relevant laws, regulations, and codes of conduct. In some jurisdictions, meals may be prohibited (e.g., VT, U.S. Dept. of Veterans Affairs
or Defense), capped (MN, NJ), or reportable (CT, DC, MA, NV, OR). If you are a licensed healthcare professional in MN, NJ, or VT, or employed by U.S. Dept. of Veterans Affairs or Defense or other jurisdiction that may prohibit or cap meals, please identify yourself to an Eisai [or Biogen] representative.
      </p>
      <p>This site contains information intended for U.S. health care professionals only.</p>
    `
  }
};
